module.exports = __webpack_public_path__ + "static/media/m14tj93.5ead3d19.png";